// extracted by mini-css-extract-plugin
module.exports = {"tileContainer":"LanguageTile_tileContainer__DelSK","contentContainer":"LanguageTile_contentContainer__1m3is","active":"LanguageTile_active__3MIZW"};